/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateChartSourceItemMutationVariables = Types.Exact<{
  input: Types.InputMaybe<Types.UpdateFactSource>;
}>;


export type UpdateChartSourceItemMutation = { __typename: 'Mutation', updateFactSourceItem: { __typename: 'SourceItem', chart: string | null, chart_id: string | null, configuration: string | null, country_code: string | null, cycle: string | null, release_info: string | null, import_limit: number | null, visible: boolean | null, category: string | null, gfk_id: number | null, import_date_offset: number | null } };


export const UpdateChartSourceItemDocument = gql`
    mutation updateChartSourceItem($input: UpdateFactSource) {
  updateFactSourceItem(input: $input) {
    chart
    chart_id
    configuration
    country_code
    cycle
    release_info
    import_limit
    visible
    category
    gfk_id
    import_date_offset
  }
}
    `;
export type UpdateChartSourceItemMutationFn = Apollo.MutationFunction<UpdateChartSourceItemMutation, UpdateChartSourceItemMutationVariables>;

/**
 * __useUpdateChartSourceItemMutation__
 *
 * To run a mutation, you first call `useUpdateChartSourceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartSourceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartSourceItemMutation, { data, loading, error }] = useUpdateChartSourceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChartSourceItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChartSourceItemMutation, UpdateChartSourceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChartSourceItemMutation, UpdateChartSourceItemMutationVariables>(UpdateChartSourceItemDocument, options);
      }
export type UpdateChartSourceItemMutationHookResult = ReturnType<typeof useUpdateChartSourceItemMutation>;
export type UpdateChartSourceItemMutationOptions = Apollo.BaseMutationOptions<UpdateChartSourceItemMutation, UpdateChartSourceItemMutationVariables>;